import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "motion/react";
import Globe, { GlobeMethods } from "react-globe.gl";
import photo1 from "../timeline-assets/photo1.jpeg";
import photo2 from "../timeline-assets/photo2.jpeg";
import photo3 from "../timeline-assets/photo3.jpeg";
import photo4 from "../timeline-assets/photo4.jpeg";
import photo5 from "../timeline-assets/photo5.jpeg";
import photo6 from "../timeline-assets/photo6.jpeg";
import photo7 from "../timeline-assets/photo7.jpeg";
import photo8 from "../timeline-assets/photo8.jpeg";
import photo9 from "../timeline-assets/photo9.jpeg";
import photo10 from "../timeline-assets/photo10.jpeg";
import photo11 from "../timeline-assets/photo11.jpeg";
import photo12 from "../timeline-assets/photo12.jpeg";
import photo13 from "../timeline-assets/photo13.jpeg";
import photo14 from "../timeline-assets/photo14.jpeg";
import photo15 from "../timeline-assets/photo15.jpeg";
import photo16 from "../timeline-assets/photo16.jpeg";
import photo17 from "../timeline-assets/photo17.jpeg";
import photo18 from "../timeline-assets/photo18.jpeg";
import photo19 from "../timeline-assets/photo19.jpeg";
import photo20 from "../timeline-assets/photo20.jpeg";

// Add future trips here. Coordinates are decimal degrees.
const TRAVEL_ENTRIES = [
  {
    date: "2023-09-09",
    displayDate: "September 9, 2023",
    title: "The night we met",
    description: "We wandered around NYC, exploring the sights and getting to know each other.",
    image: photo1,
    alt: "Ryan and Lily traveling together",
    latitude: 40.7582333333,
    longitude: -73.9851616667,
    location: "Times Square, New York City",
  },
  {
    date: "2023-10-28",
    displayDate: "October 28, 2023",
    title: "The start of our adventures",
    description: "We celebrated Halloween together and decided we wanted to continue our adventures as a couple.",
    image: photo2,
    alt: "Lily meeting Ryan's friends",
    latitude: 39.959927,
    longitude: -75.604989,
    location: "West Chester, PA",
  },
  {
    date: "2023-12-17",
    displayDate: "December 17, 2023",
    title: "DC trip",
    description: "Our first trip together with friends to Washington, DC.",
    image: photo3,
    alt: "Trip to DC",
    latitude: 38.88803,
    longitude: -77.0199888333,
    location: "Washington, DC",
  },
  {
    date: "2024-01-19",
    displayDate: "January 19, 2024",
    title: "Trying new things",
    description: "Teaching Lily how to ski at Belleayre Mountain.",
    image: photo4,
    alt: "Skiing for the first time",
    latitude: 42.1281695,
    longitude: -74.518495,
    location: "Belleayre Mountain, New York",
  },
  {
    date: "2024-02-06",
    displayDate: "February 6, 2024",
    title: "Puerto Rico Pt. 1",
    description: "A special place for us, and our first trip together as a couple.",
    image: photo5,
    alt: "A favorite travel moment",
    latitude: 18.2711966667,
    longitude: -65.7259733333,
    location: "El Yunque, Puerto Rico",
  },
  {
    date: "2024-02-10",
    displayDate: "February 10, 2024",
    title: "Meeting the family",
    description: "Ryan meeting Lily's family for the first time and learning more about what makes her so special.",
    image: photo6,
    alt: "Ryan and Lily making memories together",
    latitude: 40.717432,
    longitude: -80.099305,
    location: "Cranberry, PA",
  },
  {
    date: "2024-07-28",
    displayDate: "June 28, 2024",
    title: "A summer in Italy",
    description: "Exploring Pisa together and taking in the beauty of Italy.",
    image: photo7,
    alt: "Ryan and Lily in Pisa",
    latitude: 43.7228,
    longitude: 10.4017,
    location: "Pisa, Italy",
  },
  {
    date: "2024-07-29",
    displayDate: "June 29, 2024",
    title: "A day at sea",
    description: "Enjoying the sunshine and making memories together off the shores of Spain.",
    image: photo8,
    alt: "Ryan and Lily watching the sunset at sea",
    latitude: 41.187772,
    longitude: 2.625709,
    location: "Barcelona, Spain",
  },
  {
    date: "2024-08-01",
    displayDate: "July 1, 2024",
    title: "Tea in Tunisia",
    description: "The food tour in Tunisia brought us to new flavors and favorite memories.",
    image: photo9,
    alt: "Ryan and Lily in Tunisia",
    latitude: 36.806150,
    longitude: 10.182356,
    location: "Tunis, Tunisia",
  },
  {
    date: "2024-08-04",
    displayDate: "July 4, 2024",
    title: "Sailing around the Amalfi coast",
    description: "Navigating the seas off the coast of Italy with great food and limoncello",
    image: photo10,
    alt: "Ryan and Lily along the coast of Italy",
    latitude: 48.8584,
    longitude: 2.2945,
    location: "Paris, France",
  },
  {
    date: "2024-11-16",
    displayDate: "November 16, 2024",
    title: "Dinner in the Eiffel Tower",
    description: "A special meal in the Eiffel Tower, enjoying baguettes and wine.",
    image: photo11,
    alt: "Ryan and Lily dining in Paris",
    latitude: 48.8584,
    longitude: 2.2945,
    location: "Paris, France",
  },
  {
    date: "2024-11-23",
    displayDate: "November 23, 2024",
    title: "London calling",
    description: "Exploring London and seeing some of its most iconic landmarks.",
    image: photo12,
    alt: "Ryan and Lily by Big Ben in London",
    latitude: 51.5007,
    longitude: -0.1246,
    location: "London, England",
  },
  {
    date: "2025-03-10",
    displayDate: "March 10, 2025",
    title: "A day at Chichén-Itzá",
    description: "Taking in the history and scale of Chichén-Itzá together.",
    image: photo13,
    alt: "Ryan and Lily at Chichén-Itzá",
    latitude: 20.6843,
    longitude: -88.5678,
    location: "Chichén-Itzá, Mexico",
  },
  {
    date: "2025-09-20",
    displayDate: "September 20, 2025",
    title: "Disney",
    description: "Making magic at epcot!",
    image: photo14,
    alt: "Ryan and Lily beneath a glowing sphere",
    latitude: 28.375997,
    longitude: -81.554950,
    location: "Orlando, Florida",
  },
  {
    date: "2025-11-14",
    displayDate: "November 14, 2025",
    title: "Skiing on the Matterhorn",
    description: "Taking in the mountains and enjoying incredible views in the Alps.",
    image: photo15,
    alt: "Ryan and Lily in the mountains",
    latitude: 45.982507,
    longitude: 7.660736,
    location: "Zermatt, Switzerland",
  },
  {
    date: "2025-11-28",
    displayDate: "November 28, 2025",
    title: "Meeting the rest of the family",
    description: "Celebrating Thanksgiving with family and the people who mean the most to us.",
    image: photo16,
    alt: "Ryan and Lily with family",
    latitude: 30.251535,
    longitude: -97.784482,
    location: "Austin, Texas",
  },
  {
    date: "2026-01-31",
    displayDate: "January 31, 2026",
    title: "Finding new heights",
    description: "Exploring the red rocks and wide-open skies together.",
    image: photo17,
    alt: "Ryan and Lily among red rock formations",
    latitude: 38.878,
    longitude: -104.88,
    location: "Colorado Springs, Colorado",
  },
  {
    date: "2026-07-13",
    displayDate: "July 13, 2026",
    title: "Vegas together",
    description: "Making bank and rolling dice!",
    image: photo18,
    alt: "Ryan and Lily beneath elephant statues",
    latitude: 36.164810,
    longitude: -115.210718,
    location: "Las Vegas, Nevada",
  },
  {
    date: "2026-09-07",
    displayDate: "September 7, 2026",
    title: "The next chapter",
    description: "To be continued for the rest of our lives ❤️",
    image: photo19,
    alt: "Ryan and Lily sharing a kiss on a dock",
    latitude: 18.466086,
    longitude: -66.122229,
    location: "Old San Juan, Puerto Rico",
  },
  {
    date: "2026-10-18",
    displayDate: "October 18, 2026",
    title: "Worlds collide",
    description: "Our families meeting for game night",
    image: photo20,
    alt: "Families meeting each other",
    latitude: 39.875490,
    longitude: -75.526509,
    location: "Glen Mills, Pennsylvania",
  },
];

type StoryLocation = {
  lat: number;
  lng: number;
  location: string;
};

const STORY_LOCATIONS: StoryLocation[] = TRAVEL_ENTRIES.map(
  ({ latitude, longitude, location }) => ({
  lat: latitude,
  lng: longitude,
  location,
  })
);

function createGlobePin(point: object) {
  const { location } = point as StoryLocation;
  const pin = document.createElement("button");
  pin.className = "globe-html-pin";
  pin.type = "button";
  pin.setAttribute("aria-label", location);
  pin.title = location;

  const shape = document.createElement("span");
  shape.className = "globe-html-pin-shape";

  const tooltip = document.createElement("span");
  tooltip.className = "globe-html-pin-tooltip";
  tooltip.setAttribute("role", "tooltip");
  tooltip.textContent = location;

  pin.append(shape, tooltip);
  return pin;
}

function StoryOverviewGlobe() {
  const globeRef = useRef<GlobeMethods | undefined>(undefined);

  return (
    <div className="story-overview-globe" aria-label="Map of our travels">
      <Globe
        ref={globeRef}
        width={320}
        height={320}
        backgroundColor="rgba(0, 0, 0, 0)"
        globeImageUrl="https://unpkg.com/three-globe/example/img/earth-blue-marble.jpg"
        showAtmosphere
        atmosphereColor="#b7d4c2"
        atmosphereAltitude={0.12}
        showGraticules
        htmlElementsData={STORY_LOCATIONS}
        htmlLat="lat"
        htmlLng="lng"
        htmlAltitude={0}
        htmlElement={createGlobePin}
        htmlTransitionDuration={0}
        onGlobeReady={() => {
          globeRef.current?.pointOfView(
            { lat: 30, lng: -75, altitude: 2.25 },
            0
          );
        }}
      />
    </div>
  );
}

function StoryPhoto({
  src,
  alt,
}: {
  src: string;
  alt: string;
}) {
  const photoRef = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({
    target: photoRef,
    offset: ["start end", "end start"],
  });
  const opacity = useTransform(
    scrollYProgress,
    [0, 0.12, 0.58, 0.9, 1],
    [0, 1, 1, 0.25, 0]
  );

  return (
    <motion.figure
      className="story-photo"
      ref={photoRef}
      style={{ opacity }}
    >
      <img src={src} alt={alt} loading="lazy" />
    </motion.figure>
  );
}

export default function Travels() {
  const reducedMotion = useReducedMotion();

  return (
    <section className="guest-page story-page">
      <header className="story-header">
        <div className="story-heading">
          <p className="eyebrow">The places that brought us here</p>
          <h1>Our story</h1>
          <p className="page-intro">
            A collection of places, days, and memories we have shared along the way.
          </p>
        </div>
        <StoryOverviewGlobe />
      </header>

      <ol className="story-timeline">
        {TRAVEL_ENTRIES.map((entry) => (
          <motion.li
            className="story-entry"
            key={entry.date}
            initial={reducedMotion ? false : { opacity: 0, y: 28 }}
            whileInView={reducedMotion ? undefined : { opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.65, ease: "easeOut" }}
          >
            <div className="story-marker" aria-hidden="true" />
            <aside className="story-side-content">
              <time className="story-date" dateTime={entry.date}>
                {entry.displayDate}
              </time>
              <p className="story-location-name">{entry.location}</p>
            </aside>
            <article className="story-card">
              <StoryPhoto
                src={entry.image}
                alt={entry.alt}
              />
              <div className="story-copy">
                <h2>{entry.title}</h2>
                <p>{entry.description}</p>
              </div>
            </article>
          </motion.li>
        ))}
      </ol>
    </section>
  );
}
